import React from 'react';
import { Modal, Flex, Button, Spin, Tooltip } from 'antd';
import { ModalLayout, Content, Text } from 'components';
import MessageAlert, {
  stringToMoneyFormat,
  POINT_STORE_ID,
  HOST_URL,
  PAYMENT_PC_URL,
  PAYMENT_URL,
  jsonToQueryString,
  DOMAIN_URL,
  DEPLOY_TYPE,
  PAYMENT_STORE_ID,
  isMobile,
} from 'utils';
import Formatter from 'utils/Formatter';

import { useManualChargeJmPay } from 'hooks/JmPayHooks';
import { usePaymentCancelCard } from 'hooks/PaymentHooks.';
import { useCreateTempPayment } from 'hooks/TempHooks';

import { useUserStack } from 'store';
import { InfoCircleOutlined } from '@ant-design/icons';
import arrow_up from 'assets/arrow_up.svg';
import radio_unchecked from 'assets/radio_unchecked.svg';
import radio_checked from 'assets/radio_checked.svg';
import Logger from 'utils/logger';

const logger = new Logger('JmPayCharge');

const JmPayCharge = (props) => {
  const {
    payment,
    isOpenModal,
    setIsOpenModal,
    setPayment,
    screenSize,
    handlePaymentSubmit,
    setPaymentReturn,
    isLoading,
    setIsLoading,
    setIsProgress,
    location,
    shopOrder,
    selectedDelivery,
  } = props;
  const userInfo = useUserStack();

  // const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
  const mobileCheck = isMobile();
  const styles = {
    infoFont: {
      fontWeight: 400,
      fontSize: screenSize >= 768 ? 15 : 12,
    },
    toggleMenu: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '15px 30px',
      backgroundColor: '#fbfbfb',
      borderBottom: '1px solid #ddd',
      cursor: 'pointer',
      weight: '100%',
    },
  };
  // const [isLoading, setIsLoading] = React.useState(false);
  const [isChecked, setIsChecked] = React.useState(false);
  // const [paymentReturn, setPaymentReturn] = React.useState(null);

  const { manualChargeJmPay } = useManualChargeJmPay();
  const { cancelCard } = usePaymentCancelCard();
  const { createTempPayment } = useCreateTempPayment();

  const handleToggle = () => {
    setIsChecked((prevState) => !prevState);
  };
  /**
   * JM페이 수동 충전
   * --
   * @param {string} type
   * @param {object} result
   * @param {array} arr
   */
  const handlePayment = React.useCallback(
    async (type, result = null) => {
      const submitType = type.toLocaleUpperCase();

      if (!result) {
        return setPaymentReturn(null);
      }

      try {
        switch (submitType) {
          case 'SUCCESS':
            await handlePaymentSubmit('JM_PAY-SUCCESS', null);
            return;
          case 'FAIL':
          default:
            return MessageAlert.warning('JM페이 충전에 실패하였습니다.');
        }
      } catch (err) {
        MessageAlert.error('상품 주문에 실패하였습니다!');
      } finally {
        setPaymentReturn(null);
        setTimeout(() => setIsLoading(false), 500);
      }
    },
    // eslint-disable-next-line
    [],
  );

  /**
   * JM페이 수동 충전 팝업
   * --
   * @returns
   */
  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const { status, data, message } = await createTempPayment({
        order_info: {
          price: payment,
          user_id: userInfo?.user_id,
        },
        type: 'JM_PAY',
      });

      if (status !== 200) {
        logger.error('Temp Error!!', { status, data, message });
        MessageAlert.error('상품주문에 실패하였습니다!');
        throw new Error(message);
      }
      const tempIdx = data?.temp_id;
      const paymentData = {
        /**
         * NOTE - 결제 수단
         * 신용카드 : "1000000000"
         * */
        sndPaymethod: '1000000000', // 결제 수단
        sndStoreid: POINT_STORE_ID, // 상점 ID
        sndOrdernumber: `JM_${Formatter.dateToUnix()}`, // 주문번호

        iframeYn: 'N', // 결제창 호출방식 (Y: Layer / N: popup) [선택]

        sndGoodname: 'JM Pay 충전', // 상품명
        sndAmount: payment, // 가격
        sndOrdername: userInfo?.user_name, // 주문자명

        sndCurrencytype: 'WON', // 화폐단위
        sndShowcard: 'C', // 신용카드 표시 구분
        sndCharSet: 'utf-8', // 가맹점 문자열 체어셋
        sndReply: `${HOST_URL}/payment/kspay/rcv`,

        sndInstallmenttype: '', // 할부개월수 (세팅하신 값은 KSPAY결재팝업창에서 고객이 스크롤선택)
        sndInteresttypev: 'NONE', // 무이자 구분

        sndEmail: userInfo?.user_email, // 주문자 이메일 (신용카드거래에만 이메일 전송)
        // sndMobile: userInfo?.user_phone, // 주문자 전화번호 ('-' 미포함)

        sndEscrow: '', // 에스크로적용여부-- 0: 적용안함, 1: 적용함
        // sndVirExpDt: '', // 마감일시
        // sndVirExpTm: '', // 마감시간
        // sndStoreName: '케이에스페이(주)', // 한글 회사명(최대20byte)
        // sndStoreNameEng: 'kspay', // 영어 회사명(최대20byte)
        // sndStoreDomain: 'http://www.kspay_test.co.kr', // 회사 도메인 (http://를 포함)
        sndGoodType: '2', // 실물(1) / 디지털(2)
        sndUseBonusPoint: '', // 포인트거래시 60
        sndRtApp: 'jmcoffee://payment', // 하이브리드APP 형태로 개발시 사용하는 변수
        sndStoreCeoName: '양재석', // 카카오페이 상점대표자명
        sndStorePhoneNo: '010-5138-5511', // 카카오페이 연락처
        sndStoreAddress: '서울 강남구 도산대로11길 15 1~4층', // 카카오페이 주소
        // sndQpayType: '0',
        tempId: tempIdx,
        ...(mobileCheck
          ? {
              path: location.pathname,
              searchParams: location.search,
            }
          : {}),
      };

      const form = document.createElement('form');
      form.method = 'POST';
      let paymentURL = '';
      if (mobileCheck) {
        sessionStorage.setItem('orderData', JSON.stringify(shopOrder));
        sessionStorage.setItem(
          'deliveryAddress',
          JSON.stringify(selectedDelivery),
        );
        sessionStorage.setItem('useJmPay', 'YES');
        // sessionStorage.setItem('useJmPay', true);
        paymentURL = PAYMENT_URL;
      } else {
        paymentURL = PAYMENT_PC_URL;
      }
      form.action = paymentURL;
      form.target = '_self';

      Object.entries(paymentData).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden'; // 사용자에게는 보이지 않도록 hidden으로 설정
        input.name = key; // input의 name 속성은 객체의 key
        input.value = value; // input의 value 속성은 객체의 value
        form.appendChild(input);
      });

      form.sndReply.value = `${form.sndReply.value}${jsonToQueryString(
        paymentData,
      )}`;

      document.body.appendChild(form);
      if (isMobile()) {
        form.submit();
      } else {
        window._pay(form);
      }
    } catch (err) {
      console.error('[handleSubmit] Error!!', err);
      MessageAlert.error('JM 페이를 충전하는데 실패하였습니다.');
    }
    setIsProgress(true);
  };
  /**
   * 결제 리턴 후 제이엠페이 충전
   * --
   */
  // React.useEffect(() => {
  //   if (!paymentReturn) return;

  //   handlePayment(paymentReturn.status, paymentReturn.data);
  //   // eslint-disable-next-line
  // }, [paymentReturn]);
  /**
   * 결제 팝업 상태 확인
   * --
   */
  // React.useEffect(() => {
  //   let popupCheck;

  //   if (isLoading) {
  //     // 1초마다 팝업 상태 확인
  //     popupCheck = setInterval(() => {
  //       if (window._kspay_pop_obj?.closed) {
  //         window.closeIframe();
  //         setIsLoading(false);
  //         clearInterval(popupCheck); // 팝업이 닫히면 타이머 종료
  //       } else {
  //         return;
  //       }
  //     }, 1000);
  //   }

  //   return () => {
  //     if (popupCheck) {
  //       clearInterval(popupCheck);
  //     }
  //   };
  // }, [isLoading]);
  /**
   * 팝업 메세지 감지
   * --
   */
  // React.useEffect(() => {
  //   // 메시지 수신 핸들러
  //   const handleMessage = (event) => {
  //     const allowedOrigins = [
  //       `http://${DOMAIN_URL}${DEPLOY_TYPE === 'local' ? ':3000' : ''}`,
  //       `https://${DOMAIN_URL}${DEPLOY_TYPE === 'local' ? ':3000' : ''}`,
  //       `http://mall.${DOMAIN_URL}${DEPLOY_TYPE === 'local' ? ':3000' : ''}`,
  //       `https://mall.${DOMAIN_URL}${DEPLOY_TYPE === 'local' ? ':3000' : ''}`,
  //       `https://jm-coffee.${DOMAIN_URL}${
  //         DEPLOY_TYPE === 'local' ? ':3000' : ''
  //       }`,
  //       `https://mall-jm-coffee.${DOMAIN_URL}${
  //         DEPLOY_TYPE === 'local' ? ':3000' : ''
  //       }`,
  //     ];

  //     // 보안 체크: 같은 origin에서 온 메시지만 허용
  //     // if (!allowedOrigins.includes(event.origin)) {
  //     //   console.warn('허용되지 않은 origin:', event.origin);
  //     //   return;
  //     // }

  //     const message = event.data;

  //     // 팝업에서 보낸 데이터만 처리
  //     // NOTE: 결제 성공
  //     if (message?.source === 'payment-success') {
  //       const parseData = JSON.parse(message?.data);
  //       window.closeEvent();
  //       setPaymentReturn({
  //         status: 'success',
  //         data: parseData,
  //       });
  //     }
  //     // NOTE: 결제 실패
  //     else if (message?.source === 'payment-fail') {
  //       const parseData = JSON.parse(message?.data);
  //       window.closeEvent();

  //       setPaymentReturn({
  //         status: 'fail',
  //         data: parseData,
  //       });
  //       setIsLoading(false);
  //     }
  //   };

  //   window.addEventListener('message', handleMessage);

  //   // 컴포넌트 언마운트 시 이벤트 리스너 제거
  //   return () => {
  //     window.removeEventListener('message', handleMessage);
  //   };
  //   // eslint-disable-next-line
  // }, []);

  return (
    <>
      <Spin spinning={isLoading}>
        <Modal
          className="jm-pay-charge-modal"
          visible={isOpenModal}
          title={''}
          centered
          // okText={'충전'}
          // cancelText={'취소'}
          // onOk={() => {}}
          onCancel={() => {
            setPayment(0);
            setIsChecked(false);
            setIsOpenModal(!isOpenModal);
          }}
          zIndex={5000}
          footer={
            <Flex gap={10} justify="center">
              <Button
                onClick={() => {
                  setPayment(0);
                  setIsChecked(false);
                  setIsOpenModal(false);
                }}
              >
                취소
              </Button>
              <Tooltip
                title={!isChecked ? '유의사항 동의 후 충전이 가능합니다.' : ''}
              >
                <Button
                  type="primary"
                  disabled={!isChecked}
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  충전
                </Button>
              </Tooltip>
            </Flex>
          }
          // afterClose={() => setIsOpenModal(false)}
          styles={{
            body: {
              maxHeight: '60vh',
              overflowY: 'auto',
              WebkitOverflowScrolling: 'touch',
            },
          }}
        >
          <Content
            maxWidth={'100%'}
            style={{ position: 'relative', top: 0, left: 0 }}
            padding={0}
          >
            <Flex gap={30} vertical justify="center" align="center">
              <Text size={24} weight={700}>
                JM Pay 잔액 부족
              </Text>
              <Flex gap={30}>
                <Flex vertical align="center">
                  <Text style={{ color: 'var(--red-secondary-color)' }}>
                    잔액
                  </Text>
                  <Text size={18} weight={700}>
                    {stringToMoneyFormat(userInfo?.jm_pay, 'P')}
                  </Text>
                </Flex>
                <Flex vertical align="center">
                  <Text style={{ color: 'var(--red-secondary-color)' }}>
                    충전 금액
                  </Text>
                  <Text size={18} weight={700}>
                    {stringToMoneyFormat(payment, 'P')}
                  </Text>
                </Flex>
              </Flex>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  marginBottom: 15,
                }}
              >
                <span
                  style={{
                    // border: '1px solid #900020',
                    // borderRadius: 20,
                    color: '#900020',
                    padding: '5px 10px',
                  }}
                >
                  남은 한도
                </span>
                <Text>
                  {stringToMoneyFormat(500000 - userInfo?.jm_pay, '원')}
                </Text>
              </div>
              <Flex vertical>
                <Text
                  style={{
                    color: 'var(--light-gray-color)',
                  }}
                  size={14}
                >
                  <InfoCircleOutlined
                    style={{ color: '#900020', marginRight: 5 }}
                  />
                  보유 충전 한도 내에서 1회 20만원까지 충전 가능합니다.
                </Text>
                <Text
                  style={{
                    color: 'var(--light-gray-color)',
                  }}
                  size={14}
                >
                  <InfoCircleOutlined
                    style={{ color: '#900020', marginRight: 5 }}
                  />
                  카드사 정책에 따라 일부 카드는 포인트 결제금액 제한이
                  있습니다.
                </Text>
              </Flex>
              {/* <Text
                style={{
                  color: 'var(--light-gray-color)',
                  borderBottom: '1px solid var(--light-gray-color)',
                  width: 'fit-content',
                  cursor: 'pointer',
                  marginLeft: 20,
                }}
                size={14}
              >
                자세히보기 &gt;
              </Text> */}
              <Flex gap={10} vertical style={{ weight: '100%' }}>
                <div style={{ ...styles.toggleMenu }}>
                  <Text size={18} weight={500}>
                    결제 정보
                  </Text>
                </div>

                <div
                  style={{
                    display: 'flex',
                    gap: 10,
                    alignItems: 'center',
                    padding: '20px 30px',
                  }}
                >
                  <img
                    src={radio_checked}
                    alt={'Checked radio icon'}
                    style={{ cursor: 'pointer' }}
                  />
                  <p style={{ fontSize: 16 }}>신용/체크카드</p>
                </div>

                <div style={{ ...styles.toggleMenu }}>
                  <Text size={18} weight={500}>
                    유의사항
                  </Text>
                </div>
                <div
                  style={{
                    color: 'var(--light-gray-color)',
                    padding: '20px 30px',
                    fontSize: 16,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                  }}
                >
                  <div style={{ display: 'flex' }}>
                    <p style={{ marginRight: 10 }}>*</p>
                    <p>
                      보유 한도는 50만 페이입니다.
                      <br />
                      (한도 초과 시 충전이 불가능하며, 잔여 페이 소진 후
                      가능합니다.)
                    </p>
                  </div>
                  <div style={{ display: 'flex' }}>
                    <p style={{ marginRight: 10 }}>*</p>
                    <p>
                      충전 취소는 충전 이후 거래내역이 없는 경우에 한해, 충전
                      결제일로 부터 7일 이내에만 가능합니다.
                      <br />
                      (페이 &gt; 적립/사용내역 &gt; 취소할 결제건의 '충전취소'
                      선택)
                    </p>
                  </div>
                  <div style={{ display: 'flex' }}>
                    <p style={{ marginRight: 10 }}>*</p>
                    <p>
                      환불은 최종 충전 후 잔액의 60% 이상이 사용된 경우에만
                      가능합니다.
                    </p>
                  </div>
                  <div style={{ display: 'flex' }}>
                    <p style={{ marginRight: 10 }}>*</p>
                    <p>
                      충전한 페이는 제이엠커피 모든 매장에서 현금과 동일하게
                      주문결제 시 사용 가능합니다.(현금영수증 발급)
                    </p>
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    gap: 10,
                    alignItems: 'flex-start',
                    padding: '20px 30px 80px',
                  }}
                >
                  <img
                    src={isChecked ? radio_checked : radio_unchecked}
                    alt={
                      isChecked ? 'Checked radio icon' : 'Unchecked radio icon'
                    }
                    onClick={handleToggle}
                    style={{ cursor: 'pointer' }}
                  />
                  <p style={{ fontSize: 16 }}>
                    위 유의사항을 확인했으며, 개인정보 제 3자 제공 내역 및
                    결제에 동의합니다.
                  </p>
                </div>
              </Flex>
            </Flex>
          </Content>
        </Modal>
      </Spin>
    </>
  );
};

export default JmPayCharge;
